import React from 'react';
import './PrivacyPolicy.css';
import Header from './common/Header';

function PrivacyPolicy() {
    return (
        <div>
            <Header />
            <div className="policy-content">
                <h1>Политика обработки персональных данных "zametna"</h1>

                <h2>1. Преамбула</h2>
                <p>1.1. Настоящая Политика обработки персональных данных "zametna" (далее - “Политика”) является локальным
                    нормативным актом ООО Рэвл (далее - "zametna"), который определяет условия
                    обработки персональных данных, а также права и обязанности субъектов персональных данных и "zametna"
                    как оператора персональных данных.</p>
                <p>1.2. Настоящая Политика разработана в соответствии с действующим законодательством Российской
                    Федерации в области персональных данных и нормативно-методическими документами органов
                    государственной власти по вопросам безопасности персональных данных, в том числе в информационных
                    системах персональных данных. Она размещена в открытом доступе на Сайте "zametna" в соответствии с ч.2
                    ст.18.1 Федерального закона "О персональных данных".</p>
                <p>1.3. Настоящая Политика постоянно совершенствуется и в нее вносятся изменения в соответствии с
                    актуальным законодательством, поэтому "zametna" рекомендует субъектам персональных данных регулярно
                    ознакомиться с ее обновленными редакциями.</p>
                <p>1.4. Действие настоящей Политики распространяется на все случаи, когда "zametna" выступает в качестве
                    оператора персональных данных.</p>
                <p>1.5. В настоящей Политике используются следующие понятия и термины:</p>
                <ul>
                    <li>1.5.1 "zametna" - ООО Рэвл, зарегистрированный в соответствии с законодательством Российской Федерации; адрес:
                        142501, Московская обл., г.о. Подольск, Г Подольск, УЛ ЛИТЕЙНАЯ, Д. 42А, КВ. 133
                        5074093746; ОГРНИП 1255000030174;
                    </li>
                    <li>1.5.2. Персональные данные (“ПД”) – любая информация, относящаяся к прямо или косвенно
                        определенному или определяемому физическому лицу (субъекту персональных данных);
                    </li>
                    <li>1.5.3. Субъект персональных данных (“Субъект ПД”) – физическое лицо, которое прямо или косвенно
                        определено или определяется с помощью персональных данных;
                    </li>
                    <li>1.5.4. Обработка персональных данных – любое действие (операция) или совокупность действий
                        (операций), совершаемых с использованием средств автоматизации или без использования таких
                        средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение,
                        уточнение (обновление, изменение), извлечение, использование, передачу (распространение,
                        предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных;
                    </li>
                    <li>1.5.5. Оператор – государственный орган, муниципальный орган, юридическое или физическое лицо, в
                        том числе "zametna", самостоятельно или совместно с другими лицами организующие и (или)
                        осуществляющие обработку персональных данных, а также определяющие цели обработки персональных
                        данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с
                        персональными данными;
                    </li>
                    <li>1.5.6. Закон о персональных данных – Федеральный закон от 27.07.2006 N 152-ФЗ "О персональных
                        данных";
                    </li>
                </ul>

                <h2>2. Права субъекта персональных данных</h2>
                <ul>
                    <li>2.1. получать информацию, касающуюся обработки его ПД, за исключением случаев, предусмотренных
                        федеральными законами. Перечень информации и порядок ее получения установлен Законом о
                        персональных данных;
                    </li>
                    <li>2.2. требовать от "zametna" уточнения его ПД, их блокирования или уничтожения в случае, если ПД
                        являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми
                        для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих
                        прав;
                    </li>
                    <li>2.3. дать предварительное согласие на обработку ПД в целях продвижения на рынке товаров, работ и
                        услуг;
                    </li>
                    <li>2.4. обжаловать в Роскомнадзоре или в судебном порядке неправомерные действия или бездействие
                        "zametna" при обработке его ПД.
                    </li>
                </ul>

                <h2>3. Права и обязанности "zametna"</h2>
                <p>3.1. Выступая в качестве Оператора, "zametna" обязана:</p>
                <ul>
                    <li>3.1.1. организовывать обработку ПД в соответствии с требованиями Закона о персональных данных;
                    </li>
                    <li>3.1.2. предоставлять Субъекту ПД по его запросу информацию, касающуюся обработки его ПД, либо на
                        законных основания предоставить отказ;
                    </li>
                    <li>3.1.3. по требованию Субъекта ПД уточнять обрабатываемые ПД, блокировать или удалять, если ПД
                        являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми
                        для заявленной цели обработки.
                    </li>
                </ul>

                <h2>4. Объем и категории ПД, обрабатываемых "zametna"</h2>
                <p>4.1. "zametna" обрабатывает следующие категории ПД: </p>

                <div className="table-container">
                    <table className="data-table">
                        <thead>
                        <tr>
                            <th>Категории Субъектов ПД</th>
                            <th>Цели обработки ПД</th>
                            <th>Категории обрабатываемых ПД</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>Зарегистрированные пользователи сайта</td>
                            <td>Предоставление пользователю доступа к функционалу сайта, связанному с личным кабинетом
                                на
                                сайте.
                            </td>
                            <td>
                                <ul>
                                    <li>Адрес электронной почты</li>
                                    <li>Номер телефона</li>
                                    <li>Данные, относящиеся к пользователю сайта: ip-адрес, cookie, логин, пароль</li>
                                    <li>Информация об устройстве пользователя и тип браузера</li>
                                    <li>Идентификатор клиента</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Покупатели товаров и услуг на сайте</td>
                            <td>
                                <ul>
                                    <li>Прием платежей за товары и услуги</li>
                                    <li>Организация доставки товаров</li>
                                    <li>Учет товаро-движения на складе</li>
                                    <li>Клиентская поддержка</li>
                                    <li>Проведение маркетинговых акций</li>
                                    <li>Проведение электронных и SMS опросов</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Фамилия, имя, отчество</li>
                                    <li>Адрес электронной почты</li>
                                    <li>Номер телефона</li>
                                    <li>Адрес доставки</li>
                                    <li>Платежная информация (реквизиты банковской карты)</li>
                                    <li>Данные, относящиеся к пользователю сайта: ip-адрес, cookie, логин, пароль</li>
                                    <li>Информация об устройстве пользователя и тип браузера</li>
                                    <li>Идентификатор клиента</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Представители юридических лиц-партнеров, контрагенты, являющиеся индивидуальными
                                предпринимателями, сотрудники подрядных организаций
                            </td>
                            <td>
                                <ul>
                                    <li>Заключение и исполнение сделок</li>
                                    <li>Проверка контрагентов на благонадежность</li>
                                    <li>Проведение претензионной работы</li>
                                    <li>Создание базы контрагентов</li>
                                    <li>Создание базы контактных лиц контрагентов</li>
                                    <li>Формирование товарно-транспортных накладных и заказ пропусков</li>
                                    <li>Ведение расписания прибытия / отбытия водителей</li>
                                    <li>Идентификация водителей</li>
                                    <li>Учет рабочего времени сотрудников подрядной организации</li>
                                    <li>Осуществление коммуникаций между сотрудниками "zametna" и представителями
                                        контрагентов
                                    </li>
                                    <li>Отправка корреспонденции</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li>Фамилия, имя, отчество</li>
                                    <li>Паспортные данные</li>
                                    <li>ИНН</li>
                                    <li>ОГРНИП</li>
                                    <li>Должность</li>
                                    <li>Адрес электронной почты</li>
                                    <li>Номер телефона</li>
                                    <li>Адрес</li>
                                </ul>
                            </td>
                        </tr>
                        <tr>
                            <td>Категории субъектов, ПД которых обрабатываются в силу закона</td>
                            <td>Исполнение требований закона</td>
                            <td>Категории ПД, определенные законом</td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <h2>5. Основания для обработки "zametna" ПД</h2>
                <ul>
                    <li>5.1. Согласие субъекта ПД на обработку персональных данных;</li>
                    <li>5.2. Договор, заключаемый между "zametna" и субъектом ПД;</li>
                    {/*<li>5.3. Уставные документы "zametna" и ее локальные нормативные акты;</li>*/}
                    <li>5.4. Законодательные акты, регулирующие деятельность "zametna".</li>
                </ul>

                <h2>6. Условия прекращения обработки ПД</h2>
                <p>6.1. Условиями прекращения обработки ПД являются:</p>
                <ul>
                    <li>6.1.1. достижение целей обработки ПД;</li>
                    <li>6.1.2. истечение срока действия согласия;</li>
                    <li>6.1.3. отзыв согласия субъекта ПД на обработку его ПД;</li>
                    <li>6.1.4. выявление неправомерной обработки ПД.</li>
                </ul>
                <p>6.2. Отзыв согласия субъекта ПД может быть направлен "zametna" при помощи функционала Сайта (если такой
                    функционал доступен) или в письменной форме. Отзыв должен содержать информацию, позволяющую "zametna"
                    идентифицировать субъекта ПД, направляющего отзыв согласия. Отзыв не должен содержать ПД третьих
                    лиц.</p>

                <h2>7. Порядок и условия обработки персональных данных</h2>
                <p>7.1. В рамках обработки ПД "zametna" осуществляет:</p>
                <ul>
                    <li>7.1.1. сбор;</li>
                    <li>7.1.2. запись;</li>
                    <li>7.1.3. систематизацию;</li>
                    <li>7.1.4. накопление;</li>
                    <li>7.1.5. хранение;</li>
                    <li>7.1.6. уточнение (обновление, изменение);</li>
                    <li>7.1.7. извлечение;</li>
                    <li>7.1.8. использование;</li>
                    <li>7.1.9. передачу (распространение, предоставление, доступ);</li>
                    <li>7.1.10. обезличивание;</li>
                    <li>7.1.11. блокирование;</li>
                    <li>7.1.12. удаление;</li>
                    <li>7.1.13. уничтожение персональных данных.</li>
                </ul>
                <p>7.2. Обработка ПД может осуществляться "zametna":</p>
                <ul>
                    <li>7.2.1. с использованием средств автоматизации;</li>
                    <li>7.2.2. без средств автоматизации (ручная обработка);</li>
                    <li>7.2.3. смешанным способом.</li>
                </ul>
                {/*<p>7.3. В случаях, когда "zametna" не имеет возможности обрабатывать ПД самостоятельно, "zametna" может передать обработку ПД третьим лицам с согласия субъекта ПД. В таком случае обработка ПД будет осуществляться третьим лицом на основании поручения "zametna".</p>*/}
                <p>7.3. Передача персональных данных органам дознания и следствия, в Федеральную налоговую службу,
                    Социальный фонд России и другие уполномоченные органы исполнительной власти и организации
                    осуществляется в соответствии с требованиями законодательства Российской Федерации.</p>
                <p>7.4. "zametna" обязуется не раскрывать третьим лицам и не распространять ПД без согласия Субъекта ПД,
                    если иное не предусмотрено законом.</p>
                <p>7.5. При обработке ПД "zametna" обязуется принимать необходимые правовые, организационные и технические
                    меры или обеспечивать их принятие для защиты ПД от неправомерного или случайного доступа к ним,
                    уничтожения, изменения, блокирования, копирования, предоставления, распространения персональных
                    данных, а также от иных неправомерных действий в отношении ПД. Реализуя требования к защите ПД,
                    "zametna" принимает следующие меры:</p>
                <ul>
                    <li>7.5.1. определяет угрозы безопасности персональных данных при их обработке;</li>
                    <li>7.5.2. принимает локальные нормативные акты и иные документы, регулирующие отношения в сфере
                        обработки и защиты персональных данных;
                    </li>
                    <li>7.5.3. назначает лиц, ответственных за обеспечение безопасности персональных данных в
                        структурных подразделениях и информационных системах "zametna";
                    </li>
                    <li>7.5.4. создает необходимые условия для работы с персональными данными;</li>
                    <li>7.5.5. организует учет документов, содержащих персональные данные;</li>
                    <li>7.5.6. организует работу с информационными системами, в которых обрабатываются персональные
                        данные;
                    </li>
                    <li>7.5.7. хранит персональные данные в условиях, при которых обеспечивается их сохранность и
                        исключается неправомерный доступ к ним;
                    </li>
                    <li>7.5.8. организует обучение работников "zametna", осуществляющих обработку персональных данных.
                    </li>
                </ul>
                <p>7.6. Порядок хранения, уничтожения, обезличивания, актуализации, исправления, удаления ПД, а также
                    порядок работы с запросами субъектов ПД на доступ к ПД определяется соответствующими локальными
                    нормативными актами "zametna".</p>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
